// src/pages/Deposit/components/DepositSummary.jsx
export default function DepositSummary({ amount, fee, total }) {
  return (
    <div className="mt-6 bg-zinc-800/50 rounded-md p-4">
      <h3 className="text-zinc-300 font-medium mb-3">Deposit Summary</h3>
      
      <div className="flex justify-between mb-2">
        <span className="text-zinc-400">Deposit Amount</span>
        <span className="text-zinc-300">${amount.toFixed(2)}</span>
      </div>
      
      <div className="flex justify-between mb-2">
        <span className="text-zinc-400">Processing Fee</span>
        <span className="text-zinc-300">${fee.toFixed(2)}</span>
      </div>
      
      <div className="flex justify-between pt-2 mt-2 border-t border-zinc-700">
        <span className="font-medium text-zinc-300">Total Amount</span>
        <span className="font-medium text-purple-300">${total.toFixed(2)}</span>
      </div>
    </div>
  );
}
